import React, { useCallback, useState } from 'react';
import { AppButton, Preloader } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';
import { LockboxPaymentMethod, WireStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import LockboxErrorModal from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxErrorModal/LockboxErrorModal';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import useUpdateLockboxQuery from '@/modules/employer/components/Lockbox/queries/useUpdateLockbox.query';

interface Props {
  onSetVisible: (value: boolean) => void;  
}

const WireSentModal: React.FC<Props> = ({ onSetVisible }) => {
  const { originalLockbox } = useLockboxDetailsStore();
  const { updateLockbox, isLoading } = useUpdateLockboxQuery({ lockboxId: originalLockbox?.id });

  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = useCallback(async () => {
    try {
      await updateLockbox({
        lockbox_type: originalLockbox?.lockboxType,
        lockbox_status: originalLockbox?.lockboxStatus,
        account_id: originalLockbox?.accountId,
        amount: originalLockbox?.amount,
        employee_id: originalLockbox?.employeeId,
        vendor_id: originalLockbox?.checkDetails?.vendorId,
        payment_method_type: LockboxPaymentMethod.WIRE,
        wire_status_type: WireStatus.SENT,
      });
      setIsSuccess(true);
    } catch (error) {
      setIsError(true);
    }
  }, [originalLockbox, updateLockbox]);

  if (isSuccess) {
    return (
      <WarnModal
        testId="wire-was-successfully-sent_modal"
        visible
        onSetVisible={onSetVisible}
        isSuccessIcon
        header="Wire was successfully sent"
        onSubmit={handleSubmit}
        submitButtonText="Close"
      />
    );
  }

  if (isError) {
    return (
      <LockboxErrorModal
        onSubmit={handleSubmit}
        onSetVisible={onSetVisible}
        isAwaitMode
        disableAutomaticClosing
      />
    );
  }

  return (
    <WarnModal
      testId="was-wire-sent_modal"
      visible
      onSetVisible={onSetVisible}
      isPendingIcon
      isCloseButtonHidden
      header="Was wire sent?"
      buttonText="Cancel"
      onSubmit={handleSubmit}
      submitButtonNode={(
        <AppButton
          testId="was-wire-sent-yes"
          width="160px"
          onClick={handleSubmit}
        >
          {isLoading ? <Preloader /> : 'Yes'}
        </AppButton>
      )}
    />
  );
};

export default WireSentModal;
